import React from "react"

const SvgLinkedin = props => (
  <svg
    viewBox="0 0 455.731 455.731"
    width={512}
    height={512}
    className="linkedin_svg__hovered-paths"
    {...props}
  >
    <path
      d="M0 0v455.731h455.731V0H0zm139.94 375.963c0 5.804-4.705 10.509-10.509 10.509H84.71c-5.804 0-10.509-4.705-10.509-10.509V185.18c0-5.804 4.705-10.509 10.509-10.509h44.721c5.804 0 10.509 4.705 10.509 10.509v190.783zm-32.942-230.472c-20.308.411-38.155-16.551-38.151-38.188 0-20.985 17.282-38.105 38.408-38.088 20.873.017 38.088 17.257 38.043 38.234-.05 21.964-18.278 38.52-38.3 38.042zm279.886 236.662a4.362 4.362 0 01-4.364 4.362l-57.152-.014a4.364 4.364 0 01-4.362-4.363V264.331c0-10.183-4.126-19.407-10.802-26.079-6.764-6.768-16.149-10.916-26.501-10.799-20.279.229-36.454 17.068-36.454 37.348v117.323a4.362 4.362 0 01-4.364 4.362l-57.011-.014a4.363 4.363 0 01-4.361-4.362V179.034a4.363 4.363 0 014.363-4.363h55.795a4.363 4.363 0 014.363 4.363v23.418c.005-.01.225.018.599.075a64.249 64.249 0 013.52-5.658c11.628-16.688 30.96-27.606 52.842-27.606h11.47c39.996 0 72.42 32.423 72.42 72.42v140.47z"
      data-original="#000000"
      className="linkedin_svg__active-path"
      data-old_color="#000000"
      fill="#00CC83"
    />
  </svg>
)

export default SvgLinkedin
